import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import FavouriteButtonComponentQuery, {
	type FavouriteButtonComponentQuery$data,
	type FavouriteButtonComponentQuery$variables,
} from './__generated__/FavouriteButtonComponentQuery.graphql';

export function preloadFavouriteButton(contentId, userId) {
	// skip preloading on SSR if user is not logged in
	if (!Boolean(userId)) {
		return Promise.resolve({});
	}

	return query<FavouriteButtonComponentQuery$data, FavouriteButtonComponentQuery$variables>({
		query: FavouriteButtonComponentQuery,
		variables: {
			contentId,
		},
	});
}
